module.exports = __webpack_public_path__ + "static/wind-speed-8163bda7b6fc62349b5e2eb1ad151758.mp4";